/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PromisableAction } from "models/promisable-action";

export interface RegisterUserRequest extends PromisableAction {
    user: {
        nome: string;
        cpf: string;
        email: string;
        password: string;
        confirmPassword: string;
        dataNascimento: Date;
        telefone: string;
        endereco: {
            uf: string;
            municipio: string;
            bairro: string;
            logradouro: string;
            tipoLogradouro: string;
            numero: string;
            complemento?: string;
            cep: string;
        }
    }
}

interface State {
    isRequesting: boolean;
    errors: string[];
}

const initialState: State = {
    isRequesting: false,
    errors: [],
};

const registerUserSlice = createSlice({
    name: "users@registerUser",
    initialState,
    reducers: {
        registerUserRequest: (state, action: PayloadAction<RegisterUserRequest>): void => {
            state.isRequesting = true;
            state.errors = [];
        },
        registerUserSuccess: (state): void => {
            state.isRequesting = false;
        },
        registerUserFailed: (state, action: PayloadAction<string[]>): void => {
            state.isRequesting = false;
            state.errors = action.payload;
        },
    },
});

export const { registerUserFailed, registerUserRequest, registerUserSuccess } =
    registerUserSlice.actions;

export default registerUserSlice.reducer;
